// my lodash base functions
export function isArray(data: any) {
  return Object.prototype.toString.call(data) === "[object Array]";
}

export function isEmptyObject(obj: any): boolean {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
